import ru from './ru.ts'

export default { ru }
